function fetchJson(url, options = {}) {
	return fetch(url, {
		...options,
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			...(options.headers || {}),
		},
	}).then(res => {
		if (!res.ok) throw new Error('Request failed');
		return res.json();
	});
}

function buildDataUrl(root, startDate, endDate, phone) {
	const url = new URL(root.dataset.dataUrl, window.location.origin);
	url.searchParams.set('startDate', startDate);
	url.searchParams.set('endDate', endDate);
	if (phone) {
		url.searchParams.set('phone', phone);
	} else {
		url.searchParams.delete('phone');
	}
	return url.toString();
}

function buildConfirmUrl(root, orderId) {
	const base = root.dataset.confirmUrl;
	if (!base) return null;
	return new URL(`${base.replace(/\/+$/, '')}/${orderId}`, window.location.origin).toString();
}

function ensureImageModal() {
	let modal = document.querySelector('[data-kiosk-image-modal-overlay]');
	if (modal) return modal;

	modal = document.createElement('div');
	modal.setAttribute('data-kiosk-image-modal-overlay', 'true');
	modal.style.cssText = [
		'position:fixed',
		'inset:0',
		'background:rgba(0,0,0,0.75)',
		'display:none',
		'align-items:center',
		'justify-content:center',
		'padding:16px',
		'z-index:9999',
	].join(';');

	const img = document.createElement('img');
	img.setAttribute('data-kiosk-image-modal-img', 'true');
	img.style.cssText = [
		'max-width:600px',
		'max-height:600px',
		'width:100%',
		'height:auto',
		'border-radius:16px',
		'background:#fff',
		'object-fit:contain',
		'touch-action:manipulation',
	].join(';');

	modal.appendChild(img);
	document.body.appendChild(modal);

	function close() {
		modal.style.display = 'none';
		img.removeAttribute('src');
		img.removeAttribute('alt');
	}

	// Click/tap anywhere closes (including on image)
	modal.addEventListener('pointerdown', e => {
		e.preventDefault();
		close();
	});
	document.addEventListener('keydown', e => {
		if (e.key === 'Escape') close();
	});

	modal.openWith = ({ src, alt }) => {
		if (!src) return;
		img.src = src;
		img.alt = alt || '';
		modal.style.display = 'flex';
	};

	return modal;
}

export function initKioskPage() {
	const root = document.querySelector('[data-kiosk-page]');
	if (!root) return;

	const startDateInput = root.querySelector('[data-kiosk-date-start]');
	const endDateInput = root.querySelector('[data-kiosk-date-end]');
	const phoneInput = root.querySelector('[data-kiosk-phone]');
	if (!startDateInput || !endDateInput || !phoneInput) return;

	let refreshTimer = null;
	let phoneDebounceTimer = null;
	const refreshSeconds = parseInt(root.dataset.refreshSeconds || '0', 10) || 15;

	function refresh() {
		const submittedWrap = root.querySelector('[data-kiosk-submitted-content]');
		const pickupWrap = root.querySelector('[data-kiosk-pickup-content]');
		const cancelledWrap = root.querySelector('[data-kiosk-cancelled-content]');

		if (!submittedWrap && !pickupWrap && !cancelledWrap) {
			return Promise.resolve();
		}

		const url = buildDataUrl(
			root,
			startDateInput.value,
			endDateInput.value,
			phoneInput.value.trim()
		);
		return fetchJson(url).then(data => {
			if (submittedWrap) {
				submittedWrap.innerHTML = data.submittedHtml || '';
			}
			if (pickupWrap) {
				pickupWrap.innerHTML = data.pickupHtml || '';
			}
			if (cancelledWrap) {
				cancelledWrap.innerHTML = data.cancelledHtml || '';
			}
		});
	}

	function schedule() {
		clearInterval(refreshTimer);
		refreshTimer = setInterval(() => {
			refresh().catch(console.error);
		}, Math.max(5, refreshSeconds) * 1000);
	}

	function handleFilterChange() {
		const url = new URL(window.location.href);
		url.searchParams.set('startDate', startDateInput.value);
		url.searchParams.set('endDate', endDateInput.value);
		const phone = phoneInput.value.trim();
		if (phone) {
			url.searchParams.set('phone', phone);
		} else {
			url.searchParams.delete('phone');
		}
		url.searchParams.delete('date');
		window.history.replaceState({}, '', url.toString());

		refresh().catch(console.error);
	}

	startDateInput.addEventListener('change', handleFilterChange);
	startDateInput.addEventListener('input', handleFilterChange);
	endDateInput.addEventListener('change', handleFilterChange);
	endDateInput.addEventListener('input', handleFilterChange);
	phoneInput.addEventListener('change', handleFilterChange);
	phoneInput.addEventListener('input', () => {
		clearTimeout(phoneDebounceTimer);
		phoneDebounceTimer = setTimeout(handleFilterChange, 400);
	});

	document.addEventListener('click', e => {
		const btn = e.target.closest('[data-kiosk-confirm]');
		if (!btn) return;

		const orderId = btn.dataset.orderId;
		if (!orderId) return;

		btn.setAttribute('disabled', 'disabled');

		const confirmUrl = buildConfirmUrl(root, orderId);
		if (!confirmUrl) {
			btn.removeAttribute('disabled');
			return;
		}

		fetchJson(confirmUrl, {
			method: 'POST',
		})
			.then(() => refresh())
			.catch(err => {
				console.error(err);
				btn.removeAttribute('disabled');
			});
	});

	document.addEventListener('click', e => {
		const trigger = e.target.closest('[data-kiosk-image-modal]');
		if (!trigger) return;
		e.preventDefault();

		const src = trigger.dataset.imageSrc;
		const alt = trigger.dataset.imageAlt;

		const modal = ensureImageModal();
		modal.openWith({ src, alt });
	});

	refresh().catch(console.error);
	schedule();
}
